import { useState } from 'react'
import { Box, X } from 'lucide-react'

const INITIAL = { name: 'Nowy element', shape: 'box', mode: 'floor', width: 1, depth: 0.5, height: 1, elevation: 3.2, color: '#94a3b8', price: 0 }

function Field({ label, children }) {
  return <label className="modal-field"><span>{label}</span>{children}</label>
}

export default function CustomElementModal({ boothHeight, onClose, onCreate }) {
  const [form, setForm] = useState(() => ({ ...INITIAL, elevation: boothHeight + 0.8 }))
  const update = (key, value) => setForm((current) => ({ ...current, [key]: value }))
  const submit = (event) => {
    event.preventDefault()
    onCreate(form)
  }

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose() }}>
      <form className="custom-modal" onSubmit={submit}>
        <div className="modal-header">
          <div><Box size={19} /><span><strong>Nowy element 3D</strong><small>Zapisz go w bibliotece i używaj w projektach.</small></span></div>
          <button type="button" onClick={onClose} aria-label="Zamknij"><X size={19} /></button>
        </div>
        <div className="modal-grid">
          <Field label="Nazwa elementu"><input value={form.name} onChange={(event) => update('name', event.target.value)} required /></Field>
          <Field label="Rodzaj bryły">
            <select value={form.shape} onChange={(event) => update('shape', event.target.value)}>
              <option value="box">Prostopadłościan</option><option value="cylinder">Walec</option><option value="panel">Panel</option><option value="frame">Rama prostokątna</option><option value="ring">Pierścień</option>
            </select>
          </Field>
          <Field label="Sposób montażu">
            <select value={form.mode} onChange={(event) => update('mode', event.target.value)}>
              <option value="floor">Na podłodze</option><option value="suspended">Podwieszany</option>
            </select>
          </Field>
          <Field label="Kolor"><input type="color" value={form.color} onChange={(event) => update('color', event.target.value)} /></Field>
          <Field label="Szerokość (m)"><input type="number" min="0.1" step="0.05" value={form.width} onChange={(event) => update('width', Number(event.target.value))} /></Field>
          <Field label="Głębokość (m)"><input type="number" min="0.05" step="0.05" value={form.depth} onChange={(event) => update('depth', Number(event.target.value))} /></Field>
          <Field label="Wysokość (m)"><input type="number" min="0.05" step="0.05" value={form.height} onChange={(event) => update('height', Number(event.target.value))} /></Field>
          {form.mode === 'suspended' ? <Field label="Wysokość zawieszenia (m)"><input type="number" min={boothHeight} step="0.1" value={form.elevation} onChange={(event) => update('elevation', Number(event.target.value))} /></Field> : null}
          <Field label="Cena netto (zł)"><input type="number" min="0" step="10" value={form.price} onChange={(event) => update('price', Number(event.target.value))} /></Field>
        </div>
        <div className="modal-note">Element zostanie dodany do biblioteki oraz od razu umieszczony w bieżącym stoisku.</div>
        <div className="modal-actions"><button type="button" onClick={onClose}>Anuluj</button><button className="primary" type="submit">Utwórz i dodaj</button></div>
      </form>
    </div>
  )
}
